<div class="topline">

  <mat-toolbar>
    <mat-toolbar-row style="padding: 0">

      <div class="topline-row">
        <div style="flex: 1" class="site-title">
          <a [ngClass]="logoActive ?  '' : 'pointer'" href="/" (click)="home($event)"><img class="logo" src="/static/assets/logo.png"></a>
          The Three University Missions Dashboards
        </div>
        <div></div>
        <div class="no-print" style="margin: 0 24px 0 0 " *ngIf="loggedIn$ | async">
          <button mat-button (click)="university()" [color]="router.url.startsWith('/university') ? 'active' : ''">Мой университет</button>
          <button mat-button (click)="selections()" [color]="router.url.startsWith('/selections') ? 'active' : ''">Выборки</button>
          <button mat-button (click)="reports()" [color]="router.url.startsWith('/reports') ? 'active' : ''">Отчёты</button>
          <button mat-button (click)="dashboard()" [color]="router.url.startsWith('/dashboard') ? 'active' : ''">Дашборд</button>
          <button mat-button (click)="history()" [color]="router.url.startsWith('/history') ? 'active' : ''">История</button>
          <button mat-button (click)="help()" [color]="router.url.startsWith('/help') ? 'active' : ''">Помощь</button>
          <button mat-button (click)="logout()">Выход</button>
        </div>
      </div>

    </mat-toolbar-row>
  </mat-toolbar>
</div>

<div id="system-info" *ngIf="router.url == '/'" [matTooltip]="getSystemInfoTooltip()" matTooltipClass="pre-line">
  <span *ngIf="user">Пользователь: {{ user }}</span>
  <span *ngIf="license">Лицензиат: {{ license }}</span>
  <span *ngIf="database_ver">База данных: {{ database_ver|date:"dd.MM.yyyy" }}</span>
  <span *ngIf="system_ver">Версия системы: {{ system_ver }}</span>
  <span>Дата: {{ now | date:'dd.MM.yyyy' }}</span>
</div>

<div id="layout-background" *ngIf="sideActive"></div>
<app-side #sideComponentRef></app-side>

<div class="layout-container">
  <router-outlet></router-outlet>
</div>
